import { Wheel } from "../state/Wheel";
import { ChecklistItem } from "../state/ChecklistItem";
import { DayPlan } from "../state/DayPlan";
import { Goal } from "../state/Goal";
import { LifePart } from "../state/LifePart";
import { Task } from "../state/Task";
import { TaskList } from "../state/TaskList";
import { TrackedValue, Tracker } from "../state/Tracker";
import { Reflection } from "../state/Reflection";
import { WheelSnapshot } from "../state/WheelSnapshot";
import { Conclusion } from "../state/Conclusion";
import { Decision } from "../state/Decision";
import { MeSnapshot } from "../state/MeSnapshot";
import { RoleEfficiencySnapshot } from "../state/RoleEfficiencySnapshot";

export interface LastUpdate {
    uuid: string
    timestamp: number
}

export type OBJECT_TYPE = 'WHEEL' | 'LIFEPART' | 'GOAL' | 'TASK' | 'CHECKLISTITEM' | 'PLAN' | "LASTUPDATE" | "TRACKER" | "TRACKED_VALUE" | "TASKLIST" | "REFLECTION" | "WHEEL_SNAPSHOT" | "CONCLUSION" | "DECISION" | "ME_SNAPSHOT" | "ROLE_EFFICIENCY_SNAPSHOT";
export type ENTITY = Wheel | LifePart | Goal | Task | ChecklistItem | DayPlan | LastUpdate | Tracker | TrackedValue | TaskList | Reflection | WheelSnapshot | Conclusion | Decision | MeSnapshot | RoleEfficiencySnapshot;


export interface ServerUpdate {
    type: 'OBJECT' | 'ERROR' | 'SYNC_DONE' | 'STORED' | 'LIMIT' | 'READONLY';
}

/**
 * Сообщение от сервера о превышении лимита сущностей.
 * БЭКЕНД: Отправляйте это сообщение, когда клиент пытается отправить объект,
 * но лимит для данного типа сущностей превышен.
 */
export interface ServerLimitMessage extends ServerUpdate {
    type: 'LIMIT'
    object_type: OBJECT_TYPE
}

export interface ServerReadonlyMessage extends ServerUpdate {
    type: 'READONLY'
    object_type: OBJECT_TYPE
}


// Маппинг object_type → limitKey и entityName для фронтенда
export const LIMIT_INFO: Record<OBJECT_TYPE, { limitKey: keyof import("../key").Limits; entityName: string }> = {
    'LIFEPART': { limitKey: 'limit_life_part', entityName: 'Частей жизни' },
    'TRACKER': { limitKey: 'limit_trackers', entityName: 'Трекеров' },
    'TASKLIST': { limitKey: 'limit_lists', entityName: 'Списков задач' },
    'TASK': { limitKey: 'limit_tasks', entityName: 'Задач' },
    'CHECKLISTITEM': { limitKey: 'limit_checklists', entityName: 'Элементов чеклистов' },
    'WHEEL': { limitKey: 'limit_my_wheels', entityName: 'Колёс' },
    'GOAL': { limitKey: 'limit_tasks', entityName: 'Целей' }, // Пока используем тот же лимит что и для задач
    'PLAN': { limitKey: 'limit_tasks', entityName: 'Планов' },
    'LASTUPDATE': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем
    'TRACKED_VALUE': { limitKey: 'limit_trackers', entityName: 'Значений трекеров' },
    'REFLECTION': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем лимит
    'WHEEL_SNAPSHOT': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем лимит
    'CONCLUSION': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем лимит
    'DECISION': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем лимит
    'ME_SNAPSHOT': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем лимит
    'ROLE_EFFICIENCY_SNAPSHOT': { limitKey: 'limit_tasks', entityName: '' }, // Не проверяем лимит
}

export interface ServerStoredMessage extends ServerUpdate { // сервер шлет это сообщение как подтверждение тому, что получил и сохранил апдейт
    id: number;
}

export interface ServerObjectMessage extends ServerUpdate {
    type: 'OBJECT'
    uuid: string
    last_update_timestamp: number
    object_type: OBJECT_TYPE
    data: ENTITY
    toDelete: boolean
    sourceWidget?: string
}

export interface ServerErrorMessage extends ServerUpdate {
    type: "ERROR"
    message: string
}

export interface ClientUpdate {
    type: 'OBJECT' | 'SYNC'
}

export interface ClientSyncUpdate {
    type: 'SYNC'
    since?: number
}

export interface ClientObjectUpdate extends ClientUpdate {
    type: 'OBJECT'
    uuid: string
    object_type: OBJECT_TYPE
    data: Partial<ENTITY>
    toDelete: boolean
    sourceWidget?: string
}

export interface BeforeSaveHandler {
    (update: ClientObjectUpdate): ClientObjectUpdate;
}


export interface UpdateEvent {
    source: 'SERVER' | 'LOCAL' | 'OTHER_TAB'
    update: ClientUpdate | ServerUpdate
}